import React, { useState, useEffect } from 'react';
import {
  Box,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  Typography,
  FormGroup,
  Checkbox,
  Button,
  TextField,
  TextareaAutosize,
  Grid,
  Container
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as CaseType from '../../../config/caseType';
import { GENDER } from '../../../config/gender';
// page 2
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { validateGetStartedForm } from './ValidateGetStartedForm';
import * as patientActions from '../../../actions/patientActions';
import * as caseActions from '../../../actions/caseActions';
// import { useParams } from 'react-router-dom';
import * as setcasetypeAction from '../../../actions/setcasetypeAction';
import styles from '../dashboardstyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useRef } from 'react';
import { useSnackbar } from 'notistack';
import * as Constants from '../../../config/constants';
import * as loginActions from '../../../actions/loginActions';
const GetStarted = () => {
  // let { setSummaryView } = useParams();
  // console.log(setSummaryView);
  // eslint-disable-next-line react/prop-types
  // var caseId =  props !== undefined && props.caseId !== undefined ? props.caseId : 0;
  // console.log(caseId);
  // redux
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();
  // step 1
  var caseType = st.caseType;

  const [option, setOption] = useState(
    caseType === 'your child' || caseType === 'yourself' || caseType === 'your fetus'
      ? caseType
      : caseType === 'other relative' || caseType === 'other not relative'
      ? 'other relative'
      : 'your fetus'
  );
  const [mother, setMother] = useState(caseType === 'your fetus' ? true : false);
  const [showMother, setShowMother] = useState(
    caseType === 'your fetus' || caseType === 'fetus not mother' ? true : false
  );
  const [showRelative, setShowRelative] = useState(
    caseType === 'other relative' || caseType === 'other not relative'
  );

  // control navigation target when leave the page
  // const [fromMenu, setFromMenu] = useState(false);
  // flag to see if the page data changed or not
  // const [dataUpdated, setDataUpdated] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [saveSubmitted, setSaveSubmitted] = useState(false);

  const detectMobileType = () =>
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'iPhone'
      : /Android/i.test(navigator.userAgent)
      ? 'Android'
      : 'Desktop';

  const onMobile = detectMobileType() !== 'Desktop';

  // update case type when toggle with different case
  useEffect(() => {
    var caseType = st.caseType;
    setOption(
      caseType === 'your child' || caseType === 'yourself' || caseType === 'your fetus'
        ? caseType
        : caseType === 'other relative' || caseType === 'other not relative'
        ? 'other relative'
        : 'your fetus'
    );
    setMother(caseType === 'your fetus' ? true : false);
    setShowMother(caseType === 'your fetus' || caseType === 'fetus not mother' ? true : false);
    setShowRelative(caseType === 'other relative' || caseType === 'other not relative');

    // callback from other callers outside this component
    if (st.saveBasicInfo) {
      // submitUpdateCaseBasicInfo(formikAboutYou.values);
      if (formRef.current) {
        formRef.current.handleSubmit();
        dispatch(caseActions.setSaveBasicInfo(false));
      }
    }

    //banner success message
    if (saveSubmitted && !st.isUpdateCaseLoading && st.updatebasicerror === '') {
      enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });
      setSaveSubmitted(false);
    }
  }, [st.caseType, st.saveBasicInfo, st.isUpdateCaseLoading, saveSubmitted, st.updatebasicerror]);

  // step 1
  function getCaseType() {
    let casetype = option;
    if (option === 'your fetus' && mother === true) {
      casetype = 'your fetus';
    } else if (option === 'your fetus' && mother === false) {
      casetype = 'fetus not mother';
    } else if (option === 'other relative') {
      casetype = 'other relative';
    }
    return casetype;
  }
  const handleCaseTypeChange = (event) => {
    // setCaseType(event.target.value);
    setOption(event.target.value);
    if (event.target.value === 'your fetus') {
      setShowMother(true);
    } else {
      setShowMother(false);
    }
    if (event.target.value === 'other relative') {
      setShowRelative(true);
    } else {
      setShowRelative(false);
    }
    dispatch(caseActions.setDataUpdated(true));
  };

  const handleMotherCheckboxChange = (event) => {
    setMother(event.target.checked);
    dispatch(caseActions.setDataUpdated(true));
  };

  // step 2
  const dateToString = (dt) => {
    // Parse date without timezone
    if (dt === null) {
      dt = new Date();
    }
    var date_to_convert = new Date(
      dt.getUTCFullYear(),
      dt.getUTCMonth(),
      dt.getUTCDate(),
      10,
      0,
      0,
      0
    );
    return date_to_convert.toDateString().slice(4);
  };
  const submitUpdateCaseBasicInfo = (values) => {
    console.log(values);
    // alert('Submit CreateCase API\n' + JSON.stringify(values, null, 2));
    dispatch(setcasetypeAction.setCaseType(getCaseType()));
    // trim story's white space
    dispatch(
      patientActions.persistPatientInfo(
        values.firstName,
        values.lastName,
        values.dob,
        values.gender,
        values.dueDate,
        values.story.trim()
      )
    );

    var editCaseRequest = {
      caseId: st.caseId,
      caseType: getCaseType(),
      patientFirstName: values.firstName,
      patientLastName: values.lastName,
      patientDob: values.dob,
      gender: values.gender,
      dueDay: option === 'your fetus' ? values.dueDate : '',
      story: values.story
    };
    dispatch(caseActions.requestUpdateCaseBasicInfo(editCaseRequest));
    setSaveSubmitted(true);
  };

  let navigate = useNavigate();
  const handleHome = () => {
    if (st.caseId === null || st.caseId === 0 || st.caseId === undefined) {
      navigate('/sop2web/home');
      // reset flag before navigation
      dispatch(caseActions.setDataUpdated(false));
    } else {
      if (st.dataUpdated) {
        setShowDialog(true);
      } else {
        // reset flag before navigation
        dispatch(caseActions.setDataUpdated(false));
        dispatch(caseActions.setViewSummary(true));
      }
    }
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };

  const handleCancel = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialog(false);
    dispatch(caseActions.setViewSummary(true));
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
    // reset fromMenu
    // setFromMenu(false);
    // reset error when navigate out
    if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const formRef = useRef();

  return (
    <Box>
      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={{
          firstName:
            st !== undefined && st.patient.firstName !== ''
              ? st.patient.firstName
              : option === 'yourself' && st.userDetail !== null && st.userDetail.given_name !== null
              ? st.userDetail.given_name
              : '',
          lastName:
            st !== undefined && st.patient.lastName !== ''
              ? st.patient.lastName
              : option === 'yourself' &&
                st.userDetail !== null &&
                st.userDetail.family_name !== null
              ? st.userDetail.family_name
              : '',
          dob:
            st !== undefined &&
            st.patient !== undefined &&
            st.patient.dob !== null &&
            st.patient.dob !== '' &&
            st.patient.dob !== undefined
              ? dateToString(new Date(st.patient.dob))
              : dateToString(
                  new Date(
                    new Date().getFullYear() - 25,
                    new Date().getMonth(),
                    new Date().getDate()
                  )
                ),
          gender: st !== undefined ? st.patient.gender : '',
          dueDate:
            option !== 'your fetus'
              ? ''
              : st !== undefined &&
                st.patient !== undefined &&
                st.patient.dueDate !== null &&
                st.patient.dueDate !== '' &&
                st.patient.dueDate !== undefined
              ? dateToString(new Date(st.patient.dueDate))
              : dateToString(new Date()),
          story: st !== undefined ? st.patient.story : ''
        }}
        validationSchema={validateGetStartedForm}
        onSubmit={(values) => {
          // alert('Submit CreateCase API\n' + JSON.stringify(values, null, 2));
          submitUpdateCaseBasicInfo(values);
          // reset flag
          dispatch(caseActions.setDataUpdated(false));
          // reset fromMenu
          // setFromMenu(false);
        }}>
        {(formikAboutYou) => (
          <Container>
            <Box
              sx={{
                mt: 3,
                display: 'flex',
                flexDirection: 'row',
                adjustItems: 'center',
                border: 0,
                justifyContent: 'space-between'
              }}>
              <Typography variant="h6">
                Case Info for{' '}
                {st !== undefined && st.patient.firstName !== undefined && st.patient.lastName},
                {st !== undefined && st.patient.lastName !== undefined && st.patient.firstName}
                (MRN: {st !== undefined && st.patient.mrn !== undefined ? st.patient.mrn : 'N/A'})
              </Typography>
            </Box>
            <Typography style={styles.titleText}>Patient Basic Information</Typography>

            <Grid container spacing={2}>
              <Grid
                container
                item
                xs={12}
                md={6}
                lg={6}
                direction="column"
                sx={styles.blockContainerStyle}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    // alignItems: 'center',
                    border: 0,
                    mt: 2,
                    ml: 0,
                    width: 400
                  }}>
                  <Typography sx={styles.subTitleStyle}>Who is the second opinion for?</Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mb: 2,
                      ml: 0,
                      mt: 1
                    }}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                      <RadioGroup
                        aria-labelledby="option"
                        name="option"
                        value={option}
                        onChange={handleCaseTypeChange}>
                        {CaseType.PROP.map((res) => {
                          return (
                            <Box key={res.key}>
                              <FormControlLabel
                                value={res.value}
                                control={<Radio />}
                                label={
                                  <Typography
                                    style={{
                                      color: '#021D4E',
                                      fontWeight: '500',
                                      fontSize: 15,
                                      textAlign: 'left'
                                    }}>
                                    {res.text}
                                  </Typography>
                                }
                              />
                            </Box>
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  {showMother && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2,
                        ml: 0,
                        mt: 1
                      }}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox checked={mother} onChange={handleMotherCheckboxChange} />
                          }
                          label={
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 15,
                                textAlign: 'left'
                              }}>
                              I am the pregnant mother
                            </Typography>
                          }
                        />
                      </FormGroup>
                    </Box>
                  )}
                  {showRelative && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2,
                        ml: 0,
                        mt: 1
                      }}>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checkeddefaultChecked checked={true} />}
                          label={
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 15,
                                textAlign: 'left'
                              }}>
                              I am a relative
                            </Typography>
                          }
                        />
                      </FormGroup>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid
                container
                item
                xs={12}
                md={6}
                lg={6}
                direction="column"
                sx={styles.blockContainerStyle}>
                {option === 'your child' && (
                  <Typography sx={styles.subTitleStyle}>Tell us about your child</Typography>
                )}
                {option === 'yourself' && (
                  <Typography sx={styles.subTitleStyle}>Tell us about yourself</Typography>
                )}
                {option === 'your fetus' && mother === true && (
                  <Typography sx={styles.subTitleStyle}>Tell us about yourself</Typography>
                )}
                {option === 'your fetus' && mother === false && (
                  <Typography sx={styles.subTitleStyle}>Tell us about the mother</Typography>
                )}
                {option === 'other relative' && (
                  <Typography sx={styles.subTitleStyle}>Tell us about the patient</Typography>
                )}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    // alignItems: 'center',
                    justifyContent: 'flex-start',
                    border: 0,
                    mt: 0,
                    width: 400
                  }}>
                  <TextField
                    // size="small"
                    // variant="standard"
                    margin="dense"
                    required
                    fullWidth
                    id="firstName"
                    label="First name"
                    name="firstName"
                    // value={propsForm.values.firstName}
                    autoComplete="firstName"
                    inputProps={{ style: { fontSize: 16 } }}
                    InputLabelProps={{ style: { fontSize: 14 } }}
                    autoFocus
                    value={formikAboutYou.values.firstName}
                    onChange={(e) => {
                      formikAboutYou.handleChange(e);
                      dispatch(caseActions.setDataUpdated(true));
                    }}
                    error={
                      formikAboutYou.touched.firstName && Boolean(formikAboutYou.errors.firstName)
                    }
                    helperText={formikAboutYou.touched.firstName && formikAboutYou.errors.firstName}
                  />
                  <TextField
                    // size="small"
                    // variant="standard"
                    margin="dense"
                    required
                    fullWidth
                    id="lastName"
                    label="Last name"
                    name="lastName"
                    autoComplete="lastName"
                    inputProps={{ style: { fontSize: 16 } }}
                    InputLabelProps={{ style: { fontSize: 14 } }}
                    value={formikAboutYou.values.lastName}
                    onChange={(e) => {
                      formikAboutYou.handleChange(e);
                      dispatch(caseActions.setDataUpdated(true));
                    }}
                    error={
                      formikAboutYou.touched.lastName && Boolean(formikAboutYou.errors.lastName)
                    }
                    helperText={formikAboutYou.touched.lastName && formikAboutYou.errors.lastName}
                  />
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Box sx={{ mt: 2 }}>
                      {!onMobile && (
                        <DatePicker
                          floatingLabelText="Date"
                          label="Date of birth"
                          size="small"
                          id="dob"
                          maxDate={new Date()}
                          // views={['year', 'month', 'date']}
                          // openTo="year"
                          value={formikAboutYou.values.dob}
                          // disableFuture
                          // inputFormat="MM.dd.yyyy"
                          // mask="__.__.____"
                          // disableFuture
                          // showTodayButton
                          // onChange={formikAboutYou.handleChange}
                          onChange={(value) => {
                            formikAboutYou.setFieldValue('dob', dateToString(value));
                            dispatch(caseActions.setDataUpdated(true));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              fullWidth
                              name="dob"
                              inputProps={{ style: { fontSize: 16 } }}
                              InputLabelProps={{ style: { fontSize: 14 } }}
                              value={formikAboutYou.values.dob}
                              onChange={(value) => {
                                formikAboutYou.setFieldValue('dob', dateToString(value));
                                dispatch(caseActions.setDataUpdated(true));
                              }}
                              error={
                                formikAboutYou.touched.dob && Boolean(formikAboutYou.errors.dob)
                              }
                              helperText={formikAboutYou.touched.dob && formikAboutYou.errors.dob}
                            />
                          )}
                        />
                      )}
                      {onMobile && (
                        /*<TextField
                          id="date"
                          label="Date of birth"
                          type="date"
                          required
                          fullWidth
                          inputProps={{ style: { fontSize: 16 } }}
                          InputLabelProps={{ style: { fontSize: 14 } }}
                          // maxDate={new Date()}
                          // value={formikAboutYou.values.dob}
                          onChange={(value) =>
                            formikAboutYou.setFieldValue('dob', dateToString(value))
                          }
                          error={formikAboutYou.touched.dob && Boolean(formikAboutYou.errors.dob)}
                          helperText={formikAboutYou.touched.dob && formikAboutYou.errors.dob}
                        />*/
                        <DatePicker
                          views={['day']}
                          label="Date of birth"
                          maxDate={new Date()}
                          value={formikAboutYou.values.dob}
                          onChange={(newValue) => {
                            formikAboutYou.setFieldValue('dob', newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} required fullWidth helperText={'mm/dd/yyyy'} />
                          )}
                        />
                      )}
                    </Box>
                  </LocalizationProvider>
                  {option === 'your fetus' && (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Box sx={{ mt: 2 }}>
                        {!onMobile && (
                          <DatePicker
                            label="Baby due date"
                            size="small"
                            variant="standard"
                            required
                            fullWidth
                            minDate={new Date()}
                            // inputFormat="MM.dd.yyyy"
                            // mask="__.__.____"
                            value={formikAboutYou.values.dueDate}
                            onChange={(value) => {
                              formikAboutYou.setFieldValue('dueDate', dateToString(value));
                              dispatch(caseActions.setDataUpdated(true));
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // variant="standard"
                                // size="large"
                                required
                                fullWidth
                                // helperText={params?.inputProps?.placeholder}
                                inputProps={{ style: { fontSize: 16 } }}
                                InputLabelProps={{ style: { fontSize: 14 } }}
                                value={
                                  formikAboutYou.values.dueDate == ''
                                    ? dateToString(new Date())
                                    : formikAboutYou.values.dueDate
                                }
                                onChange={(value) => {
                                  formikAboutYou.setFieldValue('dueDate', dateToString(value));
                                  dispatch(caseActions.setDataUpdated(true));
                                }}
                                error={
                                  formikAboutYou.touched.dueDate &&
                                  Boolean(formikAboutYou.errors.dueDate)
                                }
                                helperText={
                                  formikAboutYou.touched.dueDate && formikAboutYou.errors.dueDate
                                }
                              />
                            )}
                          />
                        )}
                        {onMobile && (
                          /*<TextField
                            label="Baby due date"
                            type="date"
                            required
                            fullWidth
                            inputProps={{ style: { fontSize: 16 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            // minDate={new Date()}
                            onChange={(value) =>
                              formikAboutYou.setFieldValue('dueDate', dateToString(value))
                            }
                            error={
                              formikAboutYou.touched.dueDate &&
                              Boolean(formikAboutYou.errors.dueDate)
                            }
                            helperText={
                              formikAboutYou.touched.dueDate && formikAboutYou.errors.dueDate
                            }
                          />*/
                          <DatePicker
                            views={['day']}
                            label="Baby due date"
                            minDate={new Date()}
                            value={formikAboutYou.values.dueDate}
                            onChange={(newValue) => {
                              formikAboutYou.setFieldValue('dueDate', newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth helperText={'mm/dd/yyyy'} />
                            )}
                          />
                        )}
                      </Box>
                    </LocalizationProvider>
                  )}
                  {option !== 'your fetus' && (
                    <Box sx={{ mb: 2, mt: 2 }}>
                      <FormControl>
                        <FormLabel id="gender-group">
                          <Typography
                            style={{
                              color: '#021D4E',
                              fontWeight: '500',
                              fontSize: 15,
                              textAlign: 'left'
                            }}>
                            Gender&#x2a;
                          </Typography>
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="gender"
                          name="gender"
                          id="gender"
                          value={formikAboutYou.values.gender}
                          onChange={(e) => {
                            formikAboutYou.handleChange(e);
                            dispatch(caseActions.setDataUpdated(true));
                          }}>
                          {GENDER.map((res) => {
                            return (
                              <Box key={res.key}>
                                <FormControlLabel
                                  value={res.value}
                                  control={<Radio />}
                                  label={
                                    <Typography
                                      style={{
                                        color: '#021D4E',
                                        fontWeight: '500',
                                        fontSize: 15,
                                        textAlign: 'left'
                                      }}>
                                      {res.text}
                                    </Typography>
                                  }
                                />
                              </Box>
                            );
                          })}
                        </RadioGroup>

                        {formikAboutYou.touched.gender && Boolean(formikAboutYou.errors.gender) && (
                          <Typography style={styles.errorText}>
                            {formikAboutYou.errors.gender}
                          </Typography>
                        )}
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid
                container
                item
                xs={12}
                md={12}
                lg={12}
                direction="column"
                sx={styles.blockContainerStyle}>
                <Typography sx={styles.subTitleStyle}>Tell us your story</Typography>
                <Box sx={{ justifyContent: 'center', border: 0, mt: 2 }}>
                  {/* <PerfectScrollbar */}
                  {/* style={{ height: '100%', maxHeight: 'calc(60vh)', overflowX: 'hidden' }}> */}
                  <Box sx={{ mb: 0, ml: 0, mt: 2 }}>
                    <TextareaAutosize
                      aria-label="story"
                      minRows={10}
                      placeholder="Tell us your story"
                      required
                      label="Story"
                      style={{
                        width: 800,
                        fontSize: 16,
                        resize: 'vertical',
                        maxHeight: '400px',
                        overflow: 'auto',
                        pb: '300px'
                      }}
                      autoFocus
                      id="story"
                      name="story"
                      value={formikAboutYou.values.story}
                      onChange={(e) => {
                        formikAboutYou.handleChange(e);
                        dispatch(caseActions.setDataUpdated(true));
                      }}
                    />
                    {formikAboutYou.touched.story && Boolean(formikAboutYou.errors.story) && (
                      <Typography style={styles.errorText}>
                        {formikAboutYou.errors.story}
                      </Typography>
                    )}
                  </Box>
                  {/* </PerfectScrollbar> */}
                </Box>
                <Box>
                  <Typography style={styles.errorText}>{st.updatebasicerror}</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mt: 2,
                    border: 0,
                    width: 600
                  }}>
                  <Dialog
                    open={showDialog}
                    onClose={handleCancel}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        You are about to leave the form and the form contain unsaved data. Do you
                        want to save?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCancel}>No</Button>
                      <Button
                        onClick={() => {
                          // reset flag
                          dispatch(caseActions.setDataUpdated(false));
                          // reset fromMenu
                          // setFromMenu(false);
                          setShowDialog(false);
                          submitUpdateCaseBasicInfo(formikAboutYou.values);
                          dispatch(caseActions.setViewSummary(true));
                        }}
                        autoFocus>
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Button size="large" variant="contained" sx={{ mb: 5 }} onClick={handleHome}>
                    <KeyboardArrowLeft />
                    Home
                  </Button>
                  <Button
                    size="large"
                    variant="contained"
                    onClick={formikAboutYou.handleSubmit}
                    sx={{ mb: 5 }}>
                    Save
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Container>
        )}
      </Formik>
    </Box>
  );
};
export default GetStarted;
